import gql from 'graphql-tag';

export default gql`
  mutation updateExchange(
    $reservationId: Int!
    $renterPickup: Boolean
    $renterReturn: Boolean
    $ownerPickup: Boolean
    $ownerReturn: Boolean
    $lat: Float
    $lng: Float
  ) {
    updateExchange(
      reservationId: $reservationId
      renterPickup: $renterPickup
      renterReturn: $renterReturn
      ownerPickup: $ownerPickup
      ownerReturn: $ownerReturn
      lat: $lat
      lng: $lng
    ) {
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/confirmQL.js